export const translations = {
	'Connection': {
		no: 'Tilkobling',
	},
	'Credentials': {
		no: 'Legitimasjon',
	},
	'Protocol': {
		no: 'Protokoll',
	},
	'StartTLS': {
		no: 'StartTLS',
	},
	'TLS': {
		no: 'TLS',
	},
	'Port': {
		no: 'Port',
	},
	'Port is populated based on the selected protocol': {
		no: 'Porten fylles ut basert på valgt protokoll',
	},
	'Clear password': {
		no: 'Tøm passord',
	},
};
